import "./global";
import React from "react";
import ReactDOM from "react-dom/client";
import * as kiwiSdk from "@huyafed/huya-kiwi";
import { tafFetch } from "@/api/_tafFetch";
import { GAME_ID, TOOL_ID } from "@/config/env";
import logger from "@/utils/logger";
import App from "./App";
import "reset-css";
import "./styles/tokens.css";
import "./global.scss";

const logRuntimeInitializationError = (error: unknown) => {
  const message = "[GameToolRuntime] initialization failed";
  try {
    logger.error(message, { error });
  } catch (loggerError) {
    console.warn("[GameToolRuntime] SDK logger failed:", loggerError);
  }
  console.warn(`${message}:`, error);
};

try {
  void window.GameToolRuntime
    ?.init({
      gameId: GAME_ID,
      toolId: TOOL_ID,
      env: import.meta.env.MODE === "production" ? "prod" : "test",
      tafFetch,
      sdk: kiwiSdk,
    })
    .catch(logRuntimeInitializationError);
} catch (error) {
  logRuntimeInitializationError(error);
}

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
